import { useTranslation } from 'react-i18next';

import CustomButton from '../../../../../../shared/components/Buttons/CustomButton/CustomButton';
import Tooltip from '../../../../../../shared/components/Globals/Tooltip/Tooltip';
import { TRANSLATIONS_GLOBAL } from '../../../../../../shared/translations/commons';
import { TRANSLATIONS_PROSPECTS } from '../../../../../../shared/translations/prospects';

interface ICardEditButtonsProps {
  onCancel: () => void;
  onSave: () => void;
  loading?: boolean;
  saveDisabled?: boolean;
  saveTooltip?: string;
}

const CardEditButtons = ({
  onCancel,
  onSave,
  loading = false,
  saveDisabled = false,
  saveTooltip
}: ICardEditButtonsProps) => {
  const { t } = useTranslation();

  return (
    <div className="profile-card-actions">
      <CustomButton size="s" variant="default" onClick={onCancel} disabled={loading}>
        {t(TRANSLATIONS_GLOBAL.cancel)}
      </CustomButton>
      <Tooltip
        content={saveTooltip ?? ''}
        disabled={!saveDisabled || !saveTooltip}
        placement="top"
        triggerClassName="profile-card-actions__save"
      >
        <CustomButton size="s" variant="primary" onClick={onSave} loading={loading} disabled={saveDisabled}>
          {t(TRANSLATIONS_PROSPECTS.profile.actions.save)}
        </CustomButton>
      </Tooltip>
    </div>
  );
};

export default CardEditButtons;
